import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ljihdafvceqcixprqsts.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxqaWhkYWZ2Y2VxY2l4cHJxc3RzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUwMDI3NDAsImV4cCI6MjA5MDU3ODc0MH0.pI8nwo-vZ1KH1BPrImNC15pQP3oYma-40UuQrfb1uDc'

export const supabase = createClient(supabaseUrl, supabaseKey)
